import React from 'react'

const SignOutIcon = () => {
    return (
        <svg
            style={{ height: '100%' }}
            // width="25" height="24"
            viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.20195 22H9.80195C13.002 22 15.002 20 15.002 16.8L15.002 12.75H8.75195C8.34195 12.75 8.00195 12.41 8.00195 12C8.00195 11.59 8.34195 11.25 8.75195 11.25H15.002V7.2C15.002 4 13.002 2 9.80195 2H7.21195C4.01195 2 2.01195 4 2.01195 7.2L2.01195 16.8C2.00195 20 4.00195 22 7.20195 22Z" fill="#FFFFFF" />
            <path d="M19.4425 12.75L17.3725 14.82C17.2225 14.97 17.1525 15.16 17.1525 15.35C17.1525 15.54 17.2225 15.74 17.3725 15.88C17.6625 16.17 18.1425 16.17 18.4325 15.88L21.7825 12.53C22.0725 12.24 22.0725 11.76 21.7825 11.47L18.4325 8.12003C18.1425 7.83003 17.6625 7.83003 17.3725 8.12003C17.0825 8.41003 17.0825 8.89003 17.3725 9.18003L19.4425 11.25H15.0025V12.75H19.4425V12.75Z" fill="#FFFFFF" />
        </svg>

    )
}

export default SignOutIcon